export enum FinancialConnectionRefreshRequestType {
    Balance = 'balance',
    Ownership = 'ownership',
    Transactions = 'transactions',
}
